import TA from 'th-analytics';

export const taUtil = {
  pageview(title?: string, user?: string) {
    TA.send({
      hitType: 'pageview',
      page: window.location.pathname + window.location.search,
      title,
      userIdentifier: user,
    });
  },

  setUserIdentifier(identifier: string) {
    window.localStorage.setItem('ta_user_identifier', identifier);
  },

  getUserIdentifier(): string {
    return window.localStorage.getItem('ta_user_identifier') || '';
  },
}
